<template>
    <div class="container">
        <div class="sort-list text-center">
          <div class="row ">
                <div class="col-12 tit-sort"><h3>行业解决方案</h3></div>
                <div class="col-12 subtit-sort">为各行业企业提供系统解决方案</div>
          </div> 

          <div class="row text-center mar-bt1">
            <div class="col-3" v-for="(item,index) in solutions" :key="index">
              <div :class="['card-style',item.bcolor]">
                <i :class="['fa',item.ii,'fa-4x','txt-c'+(index+1),'mar-2']"></i>
                <p></p>
                <p>{{item.title}}</p>
                <p class="font-2 text-right padd-2"><router-link :to="'/prodetail/'+item.id">查看详情</router-link></p>
              </div>
            </div>
            
            
          </div>
        </div>

        <div class="sort-list text-center">
            <div class="row ">
                <div class="col-12 tit-sort"><h3>产品与服务</h3></div>
                <div class="col-12 subtit-sort">自主创新，自主研发</div>
            </div>
            <Prolist />
        </div>
        
        <div class="sort-list text-center">
            <div class="row ">
                <div class="col-12 tit-sort"><h3>业务流程</h3></div>
                <div class="col-12 subtit-sort">完备的过程管控体系</div>
            </div>
            <div class="row ">
            
                <div class="col-2 "><i class="fa fa-window-restore fa-3x txt-c1"></i><p class="con-style">需求计划</p></div>
                <div class="col-1"><img src="@/assets/images/arrow.png" /></div>
                <div class="col-1 "><i class="fa fa-tasks fa-3x txt-c2"></i><p class="con-style">设计方案</p></div>
                <div class="col-1"><img src="@/assets/images/arrow.png" /></div>
                <div class="col-1 "><i class="fa fa-file-text fa-3x txt-c3"></i><p class="con-style">程序开发</p></div>
                <div class="col-1"><img src="@/assets/images/arrow.png" /></div>
                <div class="col-1 "><i class="fa fa-sitemap fa-3x txt-c4"></i><p class="con-style">项目测试</p></div>
                <div class="col-1"><img src="@/assets/images/arrow.png" /></div>
                <div class="col-1 "><i class="fa fa-random fa-3x txt-c5"></i><p class="con-style">项目交付</p></div>
                <div class="col-1"><img src="@/assets/images/arrow.png" /></div>
                <div class="col-1 "><i class="fa fa-wrench fa-3x txt-c6"></i><p class="con-style">维护保修</p></div>
            </div>
        </div>
    </div>
</template>
<script>
import Prolist from '../components/Prolist';
export default {
    data(){
        return{
            solutions:[
              {id:5,title:'销售行业解决方案',ii:'fa-shopping-bag',bcolor:'border-success'},
              {id:6,title:'建筑行业解决方案',ii:'fa-road',bcolor:'border-info'},
              {id:7,title:'广告行业解决方案',ii:'fa-diamond',bcolor:'border-warning'},
              {id:3,title:'政府、企业、科研院所解决方案',ii:'fa-university',bcolor:'border-danger'},
            ]
        }
    },   
    
    components:{
        Prolist
    }    
}    

</script>
<style scoped>

.txt-c1{
    color: #faa296;
}
.txt-c2{
    color: #91def1;
}
.txt-c3{
    color: #f192c5;
}
.txt-c4{
    color: #ce85de;
}
.txt-c5{
    color: #48b998;
}
.txt-c6{
    color: #5c6eb1;
}
</style>